const globalStyleId = "webshop-fi-global-styles";

export function injectGlobalStyles() {
  if (typeof document === "undefined") {
    return;
  }

  if (document.getElementById(globalStyleId)) {
    return;
  }

  const style = document.createElement("style");
  style.id = globalStyleId;
  style.textContent = ".grecaptcha-badge { visibility: hidden; }";
  document.head.appendChild(style);
}
